<div class="container">
    <div class="blurb">
        {{ 'SLIICER.EDIT_SETTINGS.EXCEPTION_DAYS.EXPLANATION_BLURB' | translate }}
    </div>
    <div class="dataTable">
        <mat-table
            #table
            [dataSource]="dataSource"
            matSort
            (matSortChange)="sortData($event)"
            [matSortActive]="ExceptionDayColumns.exceptionDate"
            matSortDirection="asc"
        >
            <ng-container [matColumnDef]="ExceptionDayColumns.dayGroupName">
                <mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'SLIICER.EDIT_SETTINGS.EXCEPTION_DAYS.EXCEPTION' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index">
                    {{ row.dayGroupName}}
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="ExceptionDayColumns.exceptionDate">
                <mat-header-cell mat-sort-header *matHeaderCellDef>{{ 'COMMON.DATE_TEXT' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index">
                    {{ row.exceptionDate | date:customerDateFormat : UTC}}
                </mat-cell>
            </ng-container>
            <ng-container [matColumnDef]="ExceptionDayColumns.action">
                <mat-header-cell *matHeaderCellDef> </mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index">
                    <a mat-button [disabled]="isStudyLocked" (click)="edit(i)" matTooltip="{{ 'SLIICER.EDIT_SETTINGS.EXCEPTION_DAYS.EDIT_EXCEPTION' | translate }}">
                        <mat-icon>edit</mat-icon
                    ></a>
                    <a mat-button [disabled]="isStudyLocked" (click)="remove(i)" matTooltip="{{ 'SLIICER.EDIT_SETTINGS.EXCEPTION_DAYS.REMOVE_EXCEPTION' | translate }}">
                        <mat-icon>delete</mat-icon
                    ></a>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns"></mat-row>
        </mat-table>
    </div>
    <div class="actions">
        <div>
            <button mat-fab matTooltip="{{ 'SLIICER.EDIT_SETTINGS.EXCEPTION_DAYS.ADD_EXCEPTION' | translate }}" [disabled]="isStudyLocked" (click)="add()">
                <mat-icon>add</mat-icon>
            </button>
        </div>
    </div>
</div>
